import { Cookies } from "react-cookie-consent";
import { CookieSettings, DataLayerObject } from "./types";

export function deleteCookies(): void {
  const cookieList = Cookies.get();
  Object.keys(cookieList).forEach((item) => Cookies.remove(item));
  Cookies.set("CookieConsent", "false");
}

export const gtmVirtualPageView = (rest: DataLayerObject): void => {
  (window as any).dataLayer?.push({
    event: "cookieConsent",
    ...rest,
  });
};

export function acceptCookies(cookieSettings: CookieSettings): void {
  Cookies.set(
    "CookieConsent",
    "necessary:" +
    cookieSettings.necessary +
    ", preference:" +
    cookieSettings.preference +
    ", statistics:" +
    cookieSettings.statistics +
    ", marketing:" +
    cookieSettings.marketing
    // { domain: ".leabank.es", path: "/", expires: 30 }
  );

  gtmVirtualPageView(cookieSettings);
}
